import React from "react";
import T from "prop-types";
import { monthFullYearHyphen } from "LIB/formatters/date";
import { RepairAndHold } from "../../../inventories/components/Detail/Warnings";
import { REPAIR_AND_HOLD } from "../../../RepairOrders/constants";

function repairAndHoldLeadTime(inventory) {
  return (
    Number.isInteger(inventory.repair_and_hold_lead_time) &&
    parseInt(inventory.repair_and_hold_lead_time, 10) !== 0
  );
}

function repairAndHold(inventory) {
  return inventory.repair_status === REPAIR_AND_HOLD;
}

export default function InventoryTagDateCell({ inventory, renderDummyValues }) {
  const tagCell = (() => {
    if (renderDummyValues) {
      return "";
    } else if (repairAndHold(inventory) && repairAndHoldLeadTime(inventory)) {
      return <RepairAndHold inventory={inventory} label="R&H-LT" />;
    } else if (repairAndHold(inventory)) {
      return <RepairAndHold inventory={inventory} />;
    }
    return monthFullYearHyphen(inventory.tag_date);
  })();

  return <td className="text-center">{tagCell}</td>;
}

InventoryTagDateCell.propTypes = {
  inventory: T.shape({}).isRequired,
  renderDummyValues: T.bool
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/InventoryTagDateCell/InventoryTagDateCell.jsx